<h5>Indexadores</h5>
<p>Exibe a lista de Indexadores existentes no sistema FG2.</p>

<app-indexadores-listagem *ngIf="pesquisado && indexadores.length > 0" [indexadores]="indexadores"
    [atributosPaginacao]="atributosPaginacao">

</app-indexadores-listagem>